<template>
  <b-container class="py-5 bg-white text-center">
    <b-row>
      <!-- CCTV Security -->
      <b-col md="3" class="mb-4">
        <b-icon icon="camera-video" font-scale="4" class="mb-2 text-primary" />
        <h6 class="font-weight-bold text-uppercase">CCTV Security</h6>
      </b-col>

      <!-- Security Guard -->
      <b-col md="3" class="mb-4">
        <b-icon icon="person-fill" font-scale="4" class="mb-2 text-success" />
        <h6 class="font-weight-bold text-uppercase">Security Guard</h6>
      </b-col>

      <!-- Motivated Guards -->
      <b-col md="3" class="mb-4">
        <b-icon icon="lightbulb-fill" font-scale="4" class="mb-2 text-warning" />
        <h6 class="font-weight-bold text-uppercase">Motivated Guards</h6>
      </b-col>

      <!-- 24/7 Services -->
      <b-col md="3" class="mb-4">
        <b-icon icon="house-fill" font-scale="4" class="mb-2 text-danger" />
        <h6 class="font-weight-bold text-uppercase">24/7 Services</h6>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "FeaturesPage",
};
</script>

<style scoped>
h6 {
  font-size: 1rem;
}
</style>
